import { useLocalStorage } from './useLocalStorage';

export interface Bookmark {
  id: string;
  type: 'issue' | 'card' | 'result';
  title: string;
  timestamp: string;
}

export function useBookmarks() {
  const [bookmarks, setBookmarks] = useLocalStorage<Bookmark[]>('dtf-wizard-bookmarks', []);

  const addBookmark = (bookmark: Omit<Bookmark, 'timestamp'>) => {
    setBookmarks(prev => {
      if (prev.some(b => b.id === bookmark.id && b.type === bookmark.type)) {
        return prev;
      }
      return [...prev, { ...bookmark, timestamp: new Date().toISOString() }];
    });
  };

  const removeBookmark = (id: string, type: string) => {
    setBookmarks(prev => prev.filter(b => !(b.id === id && b.type === type)));
  };

  const isBookmarked = (id: string, type: string) => {
    return bookmarks.some(b => b.id === id && b.type === type);
  };

  const toggleBookmark = (bookmark: Omit<Bookmark, 'timestamp'>) => {
    if (isBookmarked(bookmark.id, bookmark.type)) {
      removeBookmark(bookmark.id, bookmark.type);
    } else {
      addBookmark(bookmark);
    }
  };

  return {
    bookmarks,
    addBookmark,
    removeBookmark,
    isBookmarked,
    toggleBookmark
  };
}
